module.exports = __webpack_public_path__ + "static/media/4.23600a00.jpg";